export default "__VITE_ASSET__z5tSqf4A__"